// extracted by mini-css-extract-plugin
export default {"skeletonLoader":"SkeletonField_skeletonLoader__JkkUM","loading":"SkeletonField_loading__Bzh-P"};